import { convertDateGMT } from "lib/helpers"
import useQueryParams from "hooks/useQueryParams"
import Button from "lib/components/Button"
import { LanguageContext } from "context/LanguageContext"
import { useContext, useEffect, useState } from "react"
import type { ComponentType } from "react"
import dynamic from "next/dynamic"
import type { DateRangeProps } from "react-date-range"
import "react-date-range/dist/styles.css" // main style file
import "react-date-range/dist/theme/default.css"

const DateRange = dynamic(
  () => import("react-date-range").then((m) => m.DateRange),
  { ssr: false },
) as ComponentType<DateRangeProps>
// theme css file
interface PropsCardDateMobileFilter {
  onChange?: (event: string[]) => void
  resetFilterDate?: () => void
  setOpenCard?: (value) => void
  applyFilterDate?: (event) => void
  isDesktop?: boolean
}
function CardDateFilter({
  onChange,
  resetFilterDate,
  applyFilterDate,
  isDesktop = true,
  setOpenCard,
}: PropsCardDateMobileFilter) {
  const { useTranslation: t } = useContext(LanguageContext)
  const [selectedRange, setSelectedRange] = useState<string[]>()
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ])
  const queries = useQueryParams()

  const selectionRange = {
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  }
  const dateRangeValue = queries.get("dateRange")
  useEffect(() => {
    if (dateRangeValue) {
      setState([
        {
          startDate: new Date(dateRangeValue.split(",")[0]),
          endDate: new Date(dateRangeValue.split(",")[1]),
          key: "selection",
        },
      ])
      setSelectedRange(dateRangeValue.split(","))
    }
  }, [dateRangeValue])

  return (
    <section className="top-0 left-0 right-0 bottom-0 z-40 flex h-full w-full overflow-y-auto bg-opacity-80 lg:p-4">
      <div className="flex w-full flex-col justify-between rounded border bg-white shadow-lg">
        {/* serach categories */}
        <div className="pt-3 px-3 lg:block hidden">
          <p className="font-bold text-sm">{t("range_date")}</p>
        </div>
        {/* content */}
        <div className="flex flex-row overflow-hidden lg:space-x-3 lg:px-3 lg:pt-3">
          <DateRange
            minDate={new Date()}
            editableDateInputs
            ranges={state}
            moveRangeOnFirstSelection={false}
            dateDisplayFormat="dd MMM yyyy"
            onChange={(item) => {
              setState([
                {
                  startDate: item.selection.startDate,
                  endDate: item.selection.endDate,
                  key: "selection",
                },
              ])
              const startDate = convertDateGMT(item.selection.startDate)
              const endDate = convertDateGMT(item.selection.endDate)
              setSelectedRange([startDate, endDate])
              return onChange?.([startDate, endDate])
            }}
            className="w-full"
          />
        </div>
        {/* footer */}
        <div className="flex-row items-center border-t px-3 py-3 flex">
          <Button
            variant="text"
            color="white"
            customClass={`w-10 ${selectedRange?.length > 0 && "!text-danger"}`}
            colorText="muted"
            fontWeight="semibold"
            disabled={!selectedRange}
            onClick={() => {
              if (selectedRange?.length > 0) {
                setState([selectionRange])
                setSelectedRange(null)
                if (isDesktop) {
                  resetFilterDate()
                } else {
                  applyFilterDate(null)
                }
              }
            }}>
            {t("reset")}
          </Button>
          <div className="flex w-full items-end justify-end">
            <Button
              variant="contained"
              color="primary"
              rounded="large"
              size="small"
              disabled={!selectedRange}
              onClick={() => {
                if (selectedRange?.length > 0) {
                  applyFilterDate(selectedRange)
                  if (!isDesktop) {
                    setOpenCard(false)
                  }
                }
              }}
              customClass="flex flex-wrap justify-center w-28 px-4 py-2.5 hover:bg-primary font-medium text-base text-white border border-primary rounded-md shadow-button">
              {t("apply")}
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CardDateFilter
